export default "__VITE_ASSET__LXugO$fX__"